import imageCompression from 'browser-image-compression';

export function compressImageForUpload(file: File): Promise<File> {
  return imageCompression(file, {
    maxSizeMB: 0.8,
    maxWidthOrHeight: 800,
  });
}
